import React, { useState } from 'react';
import { useCart } from '../contexts/CartContext';
import { Trash2, Plus, Minus, ShoppingBag, ArrowLeft, Lock, Tag, ShoppingCart, Package } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Cart() {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    cartTotal
  } = useCart();
  const [couponCode, setCouponCode] = useState('');
  const [note, setNote] = useState('');
  const navigate = useNavigate();
  const subtotal = cartTotal;
  const shipping = cart.length > 0 ? 5.99 : 0;
  const tax = subtotal * 0.08;
  const total = subtotal + shipping + tax;
  return <div className="w-full bg-gray-50 min-h-screen pb-20" data-id="element-486">
      {/* Simplified Banner */}
      <div className="relative overflow-hidden bg-white border-b border-gray-200" data-id="element-487">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white" data-id="element-488">
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: `linear-gradient(rgba(14,87,142,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(14,87,142,.1) 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }} data-id="element-489"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-12" data-id="element-490">
          {/* Back Button */}
          <button onClick={() => navigate('/store')} className="inline-flex items-center gap-2 text-gray-600 hover:text-[#0E578E] mb-4 sm:mb-6 transition-colors group" data-id="element-491">
            <div className="w-7 sm:w-8 h-7 sm:h-8 rounded-full bg-gray-100 group-hover:bg-[#0E578E]/10 flex items-center justify-center transition-colors" data-id="element-492">
              <ArrowLeft className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-493" />
            </div>
            <span className="text-xs sm:text-sm font-semibold" data-id="element-494">
              Continue Shopping
            </span>
          </button>

          {/* Header Content */}
          <div className="flex items-center gap-3 sm:gap-4" data-id="element-495">
            <div className="w-12 sm:w-14 h-12 sm:h-14 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] rounded-xl sm:rounded-2xl flex items-center justify-center shadow-lg" data-id="element-496">
              <ShoppingCart className="h-6 sm:h-7 w-6 sm:w-7 text-white" data-id="element-497" />
            </div>
            <div data-id="element-498">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-1" data-id="element-499">
                Checkout
              </h1>
              <p className="text-sm sm:text-base text-gray-600 font-medium" data-id="element-500">
                {cart.length} {cart.length === 1 ? 'item' : 'items'} • Review
                and checkout
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-8" data-id="element-501">
        {cart.length === 0 ?
      // Empty Cart State
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-8 sm:p-12 text-center" data-id="element-502">
            <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6" data-id="element-503">
              <ShoppingBag className="h-8 sm:h-10 w-8 sm:w-10 text-gray-400" data-id="element-504" />
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-505">
              Your cart is empty
            </h2>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6" data-id="element-506">
              Add some items to get started!
            </p>
            <button onClick={() => navigate('/store')} className="px-6 sm:px-8 py-2.5 sm:py-3 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg text-sm sm:text-base" data-id="element-507">
              Browse Store
            </button>
          </div> : <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-508">
            {/* Cart Items - Full width on mobile, 2/3 on desktop */}
            <div className="lg:col-span-2 space-y-3 sm:space-y-4" data-id="element-509">
              {cart.map(item => <div key={item.id} className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6 hover:shadow-md transition-shadow" data-id="element-510">
                  <div className="flex flex-col sm:flex-row gap-4 sm:gap-6" data-id="element-511">
                    {/* Product Image */}
                    <div className="flex-shrink-0 mx-auto sm:mx-0" data-id="element-512">
                      <img src={item.image} alt={item.name} className="w-32 h-32 sm:w-24 sm:h-24 md:w-32 md:h-32 object-cover rounded-xl" data-id="element-513" />
                    </div>

                    {/* Product Details */}
                    <div className="flex-1 min-w-0" data-id="element-514">
                      <div className="flex justify-between items-start gap-4 mb-3" data-id="element-515">
                        <div className="flex-1 min-w-0" data-id="element-516">
                          <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1 truncate" data-id="element-517">
                            {item.name}
                          </h3>
                          <p className="text-xs sm:text-sm text-gray-600 line-clamp-2" data-id="element-518">
                            {item.description}
                          </p>
                        </div>
                        <button onClick={() => removeFromCart(item.id)} className="flex-shrink-0 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all" aria-label="Remove item" data-id="element-519">
                          <Trash2 className="h-4 sm:h-5 w-4 sm:w-5" data-id="element-520" />
                        </button>
                      </div>

                      {/* Price and Quantity */}
                      <div className="flex items-center justify-between" data-id="element-521">
                        <div className="flex items-center gap-2 sm:gap-3" data-id="element-522">
                          <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="w-8 sm:w-9 h-8 sm:h-9 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors" aria-label="Decrease quantity" data-id="element-523">
                            <Minus className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-700" data-id="element-524" />
                          </button>
                          <span className="w-10 sm:w-12 text-center font-bold text-gray-900 text-sm sm:text-base" data-id="element-525">
                            {item.quantity}
                          </span>
                          <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="w-8 sm:w-9 h-8 sm:h-9 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors" aria-label="Increase quantity" data-id="element-526">
                            <Plus className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-700" data-id="element-527" />
                          </button>
                        </div>

                        <div className="text-right" data-id="element-528">
                          <div className="text-xs text-gray-500 mb-1" data-id="element-529">
                            ${item.price.toFixed(2)} each
                          </div>
                          <div className="text-lg sm:text-xl font-black text-[#0E578E]" data-id="element-530">
                            ${(item.price * item.quantity).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}

              {/* Order Note */}
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6" data-id="element-531">
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3" data-id="element-532">
                  Order Notes (Optional)
                </label>
                <textarea value={note} onChange={e => setNote(e.target.value)} rows={3} className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:ring-4 focus:ring-[#01AAE7]/10 resize-none text-xs sm:text-sm" placeholder="Add any special instructions for your order..." data-id="element-533" />
              </div>
            </div>

            {/* Order Summary - Full width on mobile, 1/3 on desktop */}
            <div className="lg:col-span-1" data-id="element-534">
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-200 p-5 sm:p-6 lg:sticky lg:top-24" data-id="element-535">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-536">
                  Order Summary
                </h2>

                {/* Coupon Code */}
                <div className="mb-4 sm:mb-6 pb-4 sm:pb-6 border-b border-gray-200" data-id="element-537">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2 sm:mb-3" data-id="element-538">
                    Promo Code
                  </label>
                  <div className="flex gap-2" data-id="element-539">
                    <div className="relative flex-1" data-id="element-540">
                      <Tag className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-400" data-id="element-541" />
                      <input type="text" value={couponCode} onChange={e => setCouponCode(e.target.value)} placeholder="Enter code" className="w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:border-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7]/20 text-xs sm:text-sm" data-id="element-542" />
                    </div>
                    <button className="px-4 sm:px-5 py-2 sm:py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-xs sm:text-sm font-bold rounded-lg transition-colors" data-id="element-543">
                      Apply
                    </button>
                  </div>
                </div>

                {/* Price Breakdown */}
                <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-6" data-id="element-544">
                  <div className="flex justify-between text-xs sm:text-sm" data-id="element-545">
                    <span className="text-gray-600" data-id="element-546">Subtotal</span>
                    <span className="font-semibold text-gray-900" data-id="element-547">
                      ${subtotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-xs sm:text-sm" data-id="element-548">
                    <span className="text-gray-600" data-id="element-549">Shipping</span>
                    <span className="font-semibold text-gray-900" data-id="element-550">
                      ${shipping.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-xs sm:text-sm" data-id="element-551">
                    <span className="text-gray-600" data-id="element-552">Tax (8%)</span>
                    <span className="font-semibold text-gray-900" data-id="element-553">
                      ${tax.toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* Total */}
                <div className="pt-4 sm:pt-6 border-t-2 border-gray-200 mb-4 sm:mb-6" data-id="element-554">
                  <div className="flex justify-between items-center" data-id="element-555">
                    <span className="text-base sm:text-lg font-bold text-gray-900" data-id="element-556">
                      Total
                    </span>
                    <span className="text-xl sm:text-2xl font-black text-[#0E578E]" data-id="element-557">
                      ${total.toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* PayPal Payment Buttons */}
                <div className="space-y-2 sm:space-y-3" data-id="element-558">
                  <button className="w-full bg-[#003087] hover:bg-[#002970] text-white font-bold py-3 sm:py-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-md text-sm sm:text-base" data-id="element-559">
                    <svg className="h-4 sm:h-5 w-4 sm:w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-560">
                      <path d="M20.905 9.5c.21-1.337.11-2.246-.36-3.13C19.644 5.036 17.835 4.5 15.28 4.5H8.307c-.49 0-.91.356-.987.842L5.05 20.455c-.058.363.214.67.58.67h4.242l1.065-6.754-.033.213c.077-.486.493-.842.987-.842h2.055c4.037 0 7.195-1.64 8.117-6.386.027-.14.05-.276.07-.408.264-1.69-.001-2.84-.93-3.93-.283-.332-.62-.61-.998-.828z" data-id="element-561" />
                    </svg>
                    <span data-id="element-562">PayPal CREDIT</span>
                  </button>

                  <button className="w-full bg-[#0070ba] hover:bg-[#005ea6] text-white font-bold py-3 sm:py-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-md text-sm sm:text-base" data-id="element-563">
                    <svg className="h-4 sm:h-5 w-4 sm:w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-564">
                      <path d="M20.905 9.5c.21-1.337.11-2.246-.36-3.13C19.644 5.036 17.835 4.5 15.28 4.5H8.307c-.49 0-.91.356-.987.842L5.05 20.455c-.058.363.214.67.58.67h4.242l1.065-6.754-.033.213c.077-.486.493-.842.987-.842h2.055c4.037 0 7.195-1.64 8.117-6.386.027-.14.05-.276.07-.408.264-1.69-.001-2.84-.93-3.93-.283-.332-.62-.61-.998-.828z" data-id="element-565" />
                    </svg>
                    <span data-id="element-566">PayPal Buy Now</span>
                  </button>

                  <button className="w-full bg-[#003087] hover:bg-[#002970] text-white font-bold py-3 sm:py-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-md text-sm sm:text-base" data-id="element-567">
                    <svg className="h-4 sm:h-5 w-4 sm:w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-568">
                      <path d="M20.905 9.5c.21-1.337.11-2.246-.36-3.13C19.644 5.036 17.835 4.5 15.28 4.5H8.307c-.49 0-.91.356-.987.842L5.05 20.455c-.058.363.214.67.58.67h4.242l1.065-6.754-.033.213c.077-.486.493-.842.987-.842h2.055c4.037 0 7.195-1.64 8.117-6.386.027-.14.05-.276.07-.408.264-1.69-.001-2.84-.93-3.93-.283-.332-.62-.61-.998-.828z" data-id="element-569" />
                    </svg>
                    <span data-id="element-570">PayPal CREDIT Buy Now</span>
                  </button>

                  <button className="w-full bg-[#2c2e2f] hover:bg-[#1a1b1c] text-white font-bold py-3 sm:py-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-md text-sm sm:text-base" data-id="element-571">
                    <svg className="h-5 sm:h-6 w-5 sm:w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-572">
                      <rect x="2" y="5" width="20" height="14" rx="2" strokeWidth="2" data-id="element-573" />
                      <path d="M2 10h20" strokeWidth="2" data-id="element-574" />
                    </svg>
                    <span data-id="element-575">Debit or Credit Card</span>
                  </button>

                  <div className="text-center mt-3 sm:mt-4" data-id="element-576">
                    <p className="text-xs text-gray-500" data-id="element-577">
                      Powered by{' '}
                      <span className="font-bold text-[#0070ba]" data-id="element-578">PayPal</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}